import { render } from "./PaymentsCard.vue?vue&type=template&id=38f05a6e&scoped=true"
import script from "./PaymentsCard.vue?vue&type=script&lang=js"
export * from "./PaymentsCard.vue?vue&type=script&lang=js"

import "./PaymentsCard.vue?vue&type=style&index=0&id=38f05a6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f05a6e"]])

export default __exports__